/**
 * Autogenerated file don't modify
 */
(function () {
var tsBuild = (function (exports) {
    'use strict';

    var Site = /** @class */ (function () {
        function Site() {
        }
        Site.init = function () {
            Site.run();
        };
        Site.run = function () {
            //Site.initResponsiveTables();
            //Site.initFrontpage();
            Site.initFixQuantity();
        };
        Site.initFixQuantity = function () {
            var quantity = document.querySelector('#moya_form_saa-felagaskraning #payment');
            if (quantity) {
                quantity.value = '1';
            }
        };
        return Site;
    }());
    /*
        private static is(bodyClass): boolean {
            return document.body.classList.contains(bodyClass);
        }

        private static initResponsiveTables(): void {
            const tables = document.querySelectorAll('body:not(.admin) main table');
            Array.prototype.forEach.call(tables, (el) => {
                const responsiveWrapper = document.createElement('div');
                responsiveWrapper.classList.add('table-responsive');

                el.parentNode.insertBefore(responsiveWrapper, el);
                responsiveWrapper.appendChild(el);
            });
        }

        private static initFrontpage(): void {
            if (!Site.is('frontpage')) {
                return;
            }
        }
    }

    */
    Site.init();

    exports.Site = Site;

    return exports;

}({}));
typeof tsBuild === 'function' && tsBuild();})();
